import React, { useState } from 'react';
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
  Container,
  Button,
  Divider
} from '@mui/material';
import ElementManagement from '../components/element-management/ElementManagement';
import SaltCompositionCalculator from '../components/salt-library/SaltCompositionCalculator';
import { Element } from '../types/Element';

// Interface for tab panel content
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`element-salt-tabpanel-${index}`}
      aria-labelledby={`element-salt-tab-${index}`}
      style={{ padding: '20px 0' }}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const ElementAndSaltManagementPage: React.FC = () => {
  const [tabValue, setTabValue] = useState<number>(0);
  const [selectedElement, setSelectedElement] = useState<Element | null>(null);
  
  // Handle tab change
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };
  
  // Handle element selection for use in salt composition
  const handleElementSelected = (element: Element) => {
    setSelectedElement(element);
    // Automatically switch to salt composition tab
    setTabValue(1);
  };
  
  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Element and Salt Management
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" paragraph>
          Manage elements and create salt compositions for your hydroponic solutions
        </Typography>
        
        <Paper elevation={3} sx={{ mt: 3, p: 0 }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="element and salt management tabs"
            sx={{ borderBottom: 1, borderColor: 'divider' }}
          >
            <Tab label="Element Management" id="element-salt-tab-0" />
            <Tab label="Salt Composition" id="element-salt-tab-1" />
          </Tabs>
          
          <Box sx={{ p: 3 }}>
            <TabPanel value={tabValue} index={0}>
              <ElementManagement onElementSelect={handleElementSelected} />
            </TabPanel>
              <TabPanel value={tabValue} index={1}>
              <SaltCompositionCalculator />
            </TabPanel>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default ElementAndSaltManagementPage;
